import { Modal } from "react-bootstrap"
import { programasCoursera } from "../../../../helpers/data"
import { getCoursera } from "../../../../../services/coursera"
import { getToken } from "../../../../helpers/validations"
import Swal from "sweetalert2"
import { addLogs } from "../../../../../services/logs_service"
import { useState } from "react"

const ModalCoursera = ({show, close, setSpinner, OrigenIdSocio}) => {

    const handleClose = () => {
        close(false)
    }

    const [isLoading, setIsLoading] = useState(false)

    const gotoCoursera = async(e) => {
        e.preventDefault()
        setIsLoading(true)
        
        try {
            let idProgramaCoursera = 0
            if (OrigenIdSocio === "36") {
                idProgramaCoursera = 2
            }
            else {
                idProgramaCoursera = 1
            }
            
            const [nuevaRuta, status] = await getCoursera(getToken(), programasCoursera.find(pc => pc.id === idProgramaCoursera))
            
            if (nuevaRuta?.includes('/')) {
                addLogs("coursera", "entro a link externo coursera")
                handleClose()
                window.open(nuevaRuta, '_blank', 'noopener,noreferrer')
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Inconvenientes en la conexión',
                    text: 'Volver a intentar en unos instantes.'
                })
            }
        } catch (error) {
            console.log(error)
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Ocurrió un error al intentar acceder a Coursera.'
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Body>
                    <div className="modal__coursera">
                        <h3>Acceder a coursera</h3>
                        <p>Serás redirigido a una página externa, si deseas continuar haz clic en "llévame a Coursera", de lo contrario haz clic en "volver" para continuar en la página actual.</p>

                        <div className="div__botones__coursera">
                            <button onClick={gotoCoursera} className="btn__coursera__go" disabled={isLoading}>
                                {isLoading ? "CARGANDO..." : "LLÉVAME A COURSERA"}
                            </button>
                            <button className="btn__coursera__volver" onClick={handleClose} disabled={isLoading}>VOLVER</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCoursera